import { type PromoCodesCreateFormType } from "./PromoCodesCreate.types";

const getDefaultExpirationDate = (): string => {
  const date = new Date();
  date.setMonth(date.getMonth() + 1);

  return date.toISOString().slice(0, 10);
};

export const defaultFormValues: PromoCodesCreateFormType = {
  amountCodes: 1,
  codePrefix: "",
  type: "freeMonths",
  codeValue: 1,
  expiresOn: getDefaultExpirationDate(),
};

export const PROMO_CODE_TYPE_OPTIONS = [{ label: "Kostenlose Monate", value: "freeMonths" as const }];
